import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { JobProcedureService } from '../../../services/sections/job/job-procedure.service';
import { GlobalSettingsService } from '../../../services/ui/global-settings.service';
import { JobProcedureFormValidationsSkipRequestDetails } from '../../../models/jobProcedureFormValidationsSkipRequestDetails';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { CompleteRequest } from '../../../models/completeRequest';
import {GenericModalComponent} from '../../generic-modal/generic-modal.component';

@Component({
  templateUrl: './reject-validations-skip-request.component.html',
  styleUrls: [
    './reject-validations-skip-request.component.scss',
    '../../stylesheets/job-actions.scss',
    '../../stylesheets/job-main.scss',
    '../../stylesheets/job-inputs.scss',
  ],
})
export class RejectValidationsSkipRequestComponent implements OnInit, AfterViewInit {
  @ViewChild('procedureFormValidationsSkipResponseModal') public procedureFormValidationsSkipResponseModal: GenericModalComponent;
  @ViewChild('procedureFormValidationsSkipResponseModalError') public procedureFormValidationsSkipResponseModalError: GenericModalComponent;
  public formModel: FormGroup;
  public jobProcedureFormValidationsSkipRequestDetails: JobProcedureFormValidationsSkipRequestDetails;
  public isLoading = false;
  public self = this;
  public readonly ButtonIcons = ButtonIcons;

  constructor(
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private jobProcedureService: JobProcedureService
  ) {}

  ngOnInit(): void {
    this.initializeData();
    this.initializeForm();
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
  }

  public submitComment(): void {
    GlobalSettingsService.isSecondaryLoaderLoading = true;

    const updateRequestModel: CompleteRequest = {
      isApproved: false,
      comment: this.formModel.get('comment')?.value,
    };

    this.jobProcedureService
        .updateJobProcedureFormValidationsSkipRequest(
            this.activatedRoute.snapshot.paramMap.get('token'),
            updateRequestModel
        )
        .subscribe(
            () => {
              GlobalSettingsService.isSecondaryLoaderLoading = false;
              this.procedureFormValidationsSkipResponseModal.open();
              this.isLoading = false;
            },
            () => {
              GlobalSettingsService.isSecondaryLoaderLoading = false;
              this.procedureFormValidationsSkipResponseModalError.open();
            }
        );
  }

  public closeProcedureFormValidationsSkipResponseModal(){
    this.procedureFormValidationsSkipResponseModal.hide();

    const parentUrl = this.router.url.split('/').slice(0, -1).join('/');
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([parentUrl]);
    });
  }

  private initializeData(): void {
    this.isLoading = true;
    this.jobProcedureFormValidationsSkipRequestDetails = this.activatedRoute.snapshot.data.procedureFormValidationsSkipDetails as JobProcedureFormValidationsSkipRequestDetails;
    this.isLoading = false;
  }

  private initializeForm(): void {
    this.formModel = new FormGroup({
      comment: new FormControl(null),
    });
  }
}
